<template>
  <header class="gridx">
    <vs-navbar
      v-model="indexActive"
      :color="topbarColor"
      class="topnavbar"
      text-color="rgba(255,255,255,0.7)"
      active-text-color="rgba(255,255,255,1)"
      id="v-step-header"
    >
      <!---
      Template logo
      -->
      <div
        slot="title"
        class="themelogo"
        @click="$router.push('/dashboard').catch(() => {})"
        style="cursor:pointer;"
      >
        <img :src="logo" v-if="logo" alt="Dashboard" style="max-height:65px" />
        <span class="logo-text" v-if="title">{{ title }}</span>
      </div>

      <vs-spacer></vs-spacer>
      <div
        class="play-tour-again"
        id="v-step-header-1"
        v-if="
          this.$route.path.replace('/', '') === 'dashboard' ||
            this.$route.path.replace('/', '') === 'points'
        "
      >
        <vs-button
          icon="info"
          color="primary"
          style="border-radius: 100px;"
          title="Przewodnik po serwisie krok po kroku"
          @click="playTourAgain"
          >Zobacz wprowadzenie</vs-button
        >
      </div>
      <div class="contact-phone  v-step-header-2">
        <vs-button
          icon="phone"
          color="warning"
          style="border-radius: 100px;"
          href="tel:48800706988"
          title="Bezpłatna infolinia"
          >800 706 988</vs-button
        >
      </div>
      <div class="contact-phone-small  v-step-header-2">
        <vs-button
          icon="phone"
          color="warning"
          style="border-radius: 100px;"
          href="tel:48800706988"
        ></vs-button>
      </div>
      <div class="contact-email  v-step-header-3">
        <vs-button
          icon="email"
          color="success"
          style="border-radius: 100px;"
          target
          href="https://www.tvokazje.pl/kontakt"
          title="Formularz kontaktowy tvokazje.pl"
          >Wyślij pytanie</vs-button
        >
      </div>
      <div class="contact-email-small  v-step-header-3">
        <vs-button
          icon="email"
          color="success"
          style="border-radius: 100px;"
          target
          href="https://www.tvokazje.pl/kontakt"
          title="Formularz kontaktowy tvokazje.pl"
        ></vs-button>
      </div>

      <!-- <vs-spacer></vs-spacer> -->
      <!---
      New mail Dropdown
      -->
      <!-- <vs-dropdown vs-trigger-click left class="cursor-pointer pr-2 pl-2 ml-1 mr-1">
        <a class="text-white-dark" href="#">
          <vs-icon icon="notifications"></vs-icon>
          <span class="dot-count vs-avatar--count badgeNumber dot-count-danger">4</span>
        </a>
        <vs-dropdown-menu class="topbar-dd common-dd mailbox">
          <div class="drop-title bg-info p-3 text-white">
            <h4 class="mb-0 mt-1">4 Nowe</h4>
            <span class="font-light">Powiadomienia</span>
          </div>
          <div v-bar class="vs-scrollable" style="height: 200px;">
            <div>
              <RecentNotification></RecentNotification>
            </div>
          </div>
          <div>
            <a class="d-block text-center text-dark p-3" href="javascript:void(0);">
              <strong>Sprawdź wszytskie</strong>
              <vs-icon icon="keyboard_arrow_right" class="ml-1"></vs-icon>
            </a>
          </div>
        </vs-dropdown-menu>
      </vs-dropdown> -->
      <!---
      New Messages Dropdown
      -->
      <!-- <vs-dropdown vs-trigger-click left class="cursor-pointer pr-2 pl-2 ml-1 mr-1"> 
        <a class="text-white-dark" href="#">
          <vs-icon icon="mode_comment"></vs-icon>
          <span class="dot-count vs-avatar--count badgeNumber dot-count-danger">5</span>
        </a>
        <vs-dropdown-menu class="topbar-dd common-dd mailbox">
          <div class="drop-title bg-danger p-3 text-white">
            <h4 class="mb-0 mt-1">5 nowych</h4>
            <span class="font-light">Wiadomości</span>
          </div>
          <div v-bar class="vs-scrollable" style="height: 200px;">
            <div>
              <RecentMessages></RecentMessages>
            </div>
          </div>
          <div>
            <a class="d-block text-center text-dark p-3" href="javascript:void(0);">
              <strong>Sprawdź wszystkie</strong>
              <vs-icon icon="keyboard_arrow_right" class="ml-1"></vs-icon>
            </a>
          </div>
        </vs-dropdown-menu>
      </vs-dropdown> -->
      <!---
      Craete new dd
      -->
      <vs-switch
        title="Zmień styl strony"
        id="v-step-header-5"
        v-model="theme_dark"
        vs-icon-off="wb_sunny"
        vs-icon-on="brightness_2"
        color="dark"
      />

      <vs-dropdown
        vs-trigger-click
        left
        class="cursor-pointer pr-2 pl-2 ml-1 mr-md-3"
        id="v-step-header-4"
        title="Twój profil i wyloguj"
      >
        <a class="text-white-dark user-image" href="#">
          <img src="@/assets/images/users/user.jpg" alt="User" />
        </a>
        <vs-dropdown-menu class="user-dd common-dd topbar-dd">
          <div v-for="user in users" :key="user.usertitle">
            <div
              class="d-flex align-items-center p-3 bg-warning text-white mb-2"
            >
              <div class>
                <img
                  :src="require('@/assets/images/users/user.jpg')"
                  alt="user"
                  class="rounded-circle"
                  width="60"
                />
              </div>
              <div class="ml-2">
                <h4 class="mb-0 text-white">{{ user.name }}</h4>
                <p class="mb-0">{{ user.email }}</p>
              </div>
            </div>
            <router-link to="/personal">
              <vs-dropdown-item>
                <vs-icon icon="person_outline" class="mr-1"></vs-icon>
                {{ user.dditem1 }}
              </vs-dropdown-item>
            </router-link>

            <router-link to="/history">
              <vs-dropdown-item>
                <vs-icon icon="history" class="mr-1"></vs-icon>
                {{ user.dditem2 }}
              </vs-dropdown-item>
            </router-link>
            <!-- <router-link to="/points">
              <vs-dropdown-item>
                <vs-icon icon="redeem" class="mr-1"></vs-icon>
                {{user.dditem3}}
              </vs-dropdown-item>
            </router-link> -->
            <hr class="mt-1" />
            <vs-button
              @click="logout()"
              color="danger"
              type="filled"
              size="medium"
              class="rounded-button ml-3 mb-3"
              >Wyloguj</vs-button
            >
          </div>
        </vs-dropdown-menu>
      </vs-dropdown>
    </vs-navbar>
  </header>
</template>

<script>
//import RecentMessages from "../../../views/widgets/other-widgets/recent-messages/RecentMessages";
//import RecentNotification from "../../../views/widgets/other-widgets/recent-notifications/RecentNotifications";
import axios from "axios";
import userDataMixin from "../../../mixins/userDataMixin";

export default {
  name: "Navbar",
  mixins: [userDataMixin],
  props: {
    topbarColor: {
      type: String,
      default: "#2962ff"
    },
    title: {
      type: String
    },
    logo: {
      type: String
    },
    // Obj for Userdropdown
    user: Object
  },
  data: () => ({
    indexActive: 0,
    showToggle: false,
    searchvalue: "",
    name: "",
    surname: "",
    email: ""
  }),
  created() {
    this.getData();
  },
  methods: {
    logout() {
      sessionStorage.removeItem("userToken");
      delete axios.defaults.headers.common["Authorization"];
      this.$router.push("/login");
      this.theme_dark = false
    },
    playTourAgain() {
      sessionStorage.setItem(
        this.$route.path.replace("/", "") + "Tutorial",
        "false"
      );
      this.$tours["myTour"].start();
    }
  },
  computed: {
    users: function() {
      return [
        {
          img: "/1.jpg",
          name: this.name + " " + this.surname,
          email: this.email,
          dditem1: "Mój profil",
          dditem2: "Historia",
          dditem3: "Wymiana punktów"
        }
      ];
    },
    theme_dark: {
      get() {
        let theme = this.$store.state.theme;
        if (theme == "light") return false;
        else if (theme == "dark") return true;
        else return false;
      },
      set(val) {
        if (val == false) this.$store.commit("SET_THEME", "light");
        else this.$store.commit("SET_THEME", "dark");
      }
    }
  },
  components: {
    //RecentMessages,
    //RecentNotification,
  }
};
</script>

<style>
.vs-switch {
  width: 55px !important;
  height: 28px;
  border-radius: 15px;
}
.vs-switch--circle {
  width: 24px !important;
  height: 24px !important;
}
.vs-switch.vs-switch-active .vs-switch--circle {
  margin-left: calc(100% - 28px) !important;
  width: 24px !important;
  height: 24px !important;
}
.contact-email,
.contact-phone,
.contact-phone-small,
.contact-email-small,
.play-tour-again {
  margin: 0 10px 0 0;
}
@media screen and (max-width: 429px) {
  .contact-email,
  .contact-phone {
    display: none;
  }
  .contact-phone-small,
  .contact-email-small {
    display: inline-block;
  }
}
@media screen and (min-width: 430px) {
  .contact-email,
  .contact-phone {
    display: inline-block;
  }
  .contact-phone-small,
  .contact-email-small {
    display: none;
  }
}
</style>
